import { ApplicationRef, Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Retira a tiempo la máscara de los paneles laterales (p-drawer).
 *
 * El p-drawer crea su máscara a mano en el <body> y la quita en el `animationend` de su
 * animación de salida. Con las animaciones de Angular activas (las usa el menú lateral), ese
 * retiro queda en cola hasta la siguiente detección de cambios, y sin zone.js un
 * `animationend` no dispara ninguna. Si el panel se cerró desde la pantalla (Cancelar,
 * Aplicar, Guardar), la máscara ya transparente se quedaba encima y se comía todos los clics:
 * la pantalla parecía congelada hasta salir de ella.
 *
 * Aquí se pide esa vuelta en cuanto termina la salida de cualquier máscara. Ojo: sin zone.js
 * `appRef.tick()` no hace nada si ninguna vista quedó marcada; por eso se marca la raíz y la
 * propia app programa la vuelta. Se instala una vez al arranque de la app.
 */
@Injectable({ providedIn: 'root' })
export class OverlayMaskCleanupService {
  private readonly appRef = inject(ApplicationRef);
  private readonly document = inject(DOCUMENT);
  private installed = false;

  install(): void {
    if (this.installed || typeof window === 'undefined') return;
    this.installed = true;

    this.document.addEventListener('animationend', (ev: AnimationEvent) => {
      const el = ev.target as Element | null;
      if (!el?.classList?.contains('p-overlay-mask-leave-active')) return;
      // El retiro ya lo pidió el propio panel en la fase del elemento; esto sólo lo ejecuta.
      this.appRef.components.forEach((c) => c.changeDetectorRef.markForCheck());
    });
  }
}
